"use strict";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e2) { throw _e2; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e3) { didErr = true; err = _e3; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr && (typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]); if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

// = i nclude ../../node_modules/body-scroll-lock/lib/bodyScrollLock.min.js
// = i nclude ../../node_modules/smooth-scroll/dist/smooth-sc roll.polyfills.min.js

/**
   * Get a query variable from the URL
   * As per https://css-tricks.com/snippets/javascript/get-url-variables/
   * params without a value will be set to true if they exist
   * @param variable
   * @returns {string|boolean}
   */
function m3_getQueryVariable(variable) {
  var query = window.location.search.substring(1);
  var vars = query.split("&");

  for (var i = 0; i < vars.length; i++) {
    var pair = vars[i].split("=");

    if (pair[0] == variable) {
      return typeof pair[1] == 'undefined' ? true : pair[1];
    }
  }

  return false;
}

(function ($ //, api
) {
  (function () {
    // as per https://stackoverflow.com/a/59417985/826194
    // Based on easing equations from Robert Penner (http://www.robertpenner.com/easing)
    var baseEasings = {};
    $.each(["Quad", "Cubic", "Quart", "Quint", "Expo"], function (i, name) {
      baseEasings[name] = function (p) {
        return Math.pow(p, i + 2);
      };
    });
    $.extend(baseEasings, {
      Sine: function Sine(p) {
        return 1 - Math.cos(p * Math.PI / 2);
      },
      Circ: function Circ(p) {
        return 1 - Math.sqrt(1 - p * p);
      },
      Elastic: function Elastic(p) {
        return p === 0 || p === 1 ? p : -Math.pow(2, 8 * (p - 1)) * Math.sin(((p - 1) * 80 - 7.5) * Math.PI / 15);
      },
      Back: function Back(p) {
        return p * p * (3 * p - 2);
      },
      Bounce: function Bounce(p) {
        var pow2,
            bounce = 4;

        while (p < ((pow2 = Math.pow(2, --bounce)) - 1) / 11) {}

        return 1 / Math.pow(4, 3 - bounce) - 7.5625 * Math.pow((pow2 * 3 - 2) / 22 - p, 2);
      }
    });
    $.each(baseEasings, function (name, easeIn) {
      $.easing["easeIn" + name] = easeIn;

      $.easing["easeOut" + name] = function (p) {
        return 1 - easeIn(1 - p);
      };

      $.easing["easeInOut" + name] = function (p) {
        return p < 0.5 ? easeIn(p * 2) / 2 : 1 - easeIn(p * -2 + 2) / 2;
      };
    });
  })();

  var M3SmoothScroll = /*#__PURE__*/function () {
    function M3SmoothScroll() {
      _classCallCheck(this, M3SmoothScroll);

      this.debug = typeof m3_getQueryVariable == 'function' ? m3_getQueryVariable('debug-smooth-scroll') : false;
      this.is_animating = false;
      this.config = {
        top_padding: 37,
        easing: "easeInOutQuint",
        duration: 800
      };
      if (this.debug) console.log('M3SmoothScroll: constructor()');
      this.hashlink = false;
      this.init();
    }

    _createClass(M3SmoothScroll, [{
      key: "init",
      value: function init() {
        var _this = this;

        this.hashlink = false;
        if (this.debug) console.log('M3SmoothScroll: init()', window.location.hash);

        if (window.location.hash) {
          this.hashlink = window.location.hash.substring(1).toLowerCase(); //Puts hash in variable, and removes the # character

          if (this.debug) console.log('M3SmoothScroll: hazHash', this.hashlink);
          window.location.hash = "";
        } // this.scroller = new SmoothScroll('a[href*="#"]', {
        //   speed: 1750,
        //   speedAsDuration: true,
        //   easing: 'easeInOutQuint'
        // });


        $(window).load(function () {
          _this.onLoad();
        });
      }
    }, {
      key: "scrollTo",
      value: function scrollTo(ele) {
        var _this2 = this;

        if (this.debug) console.log('scrollTo:', ele);

        if (ele && $(ele) && $(ele).offset()) {
          if (this.is_animating) {
            if (this.debug) console.log('stopping animation');
            this.stopScroll();
          }

          this.is_animating = true;
          var scroll_y = $(ele).offset().top - this.config.top_padding;
          if (this.debug) console.log('scrollTo: ', scroll_y);
          $([document.documentElement]).animate({
            scrollTop: scroll_y
          }, this.config.duration, this.config.easing, function () {
            _this2.is_animating = false;
            if (_this2.debug) console.log('animate done');
          });
        } else {
          if (this.debug) console.log('scrollTo: couldn\'t find offset');
        }
      }
      /**
       *
       * @param ele
       * @returns {string[prefix, hashlink]}
       * @private
       */

    }, {
      key: "_parseLink",
      value: function _parseLink(ele) {
        var ret = ['', ''];

        if ($(ele).attr('href')) {
          ret[0] = $(ele).attr('href').substr(0, $(ele).attr('href').indexOf('#'));
          ret[1] = $(ele).attr('href').substr($(ele).attr('href').indexOf('#') + 1);
        }

        return ret;
      }
    }, {
      key: "_disableLink",
      value: function _disableLink(ele) {
        $(ele).parent().removeClass('active');
        $(ele).parent().removeClass('current_page_item');
      }
    }, {
      key: "_enableLink",
      value: function _enableLink(ele) {
        $(ele).parent().addClass('active');
        $(ele).parent().addClass('current_page_item');
      }
    }, {
      key: "_isLink2CurrentPage",
      value: function _isLink2CurrentPage(ele) {
        // remove the domain from the href
        if (!ele.href) {
          return false;
        }

        var target_link = ele.href.replace(window.location.origin, '');
        return target_link === window.location.pathname;
      }
    }, {
      key: "markActiveHeaderLink",
      value: function markActiveHeaderLink() {
        var _this3 = this;

        var ele = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

        // we don't have a link to set active so find the currently active one
        if (ele == null) {
          // check all links in header
          $('section[m3id="header"] a').each(function (index, ele) {
            // if it has a hashlink but not the correct one, remove active
            if ($(ele).attr('href') && $(ele).attr('href').indexOf('#') >= 0) {
              var link = _this3._parseLink(ele);

              if (_this3.hashlink === false) {
                _this3._disableLink(ele);
              }
            }
          }); // we have a link to set active
        } else {
          $('[m3id="header"]').find('a').each(function (index, ele) {
            _this3._disableLink(ele);
          });

          this._enableLink(ele);
        }
      }
    }, {
      key: "onLinkClick",
      value: function onLinkClick(eve) {
        if (this.debug) console.log('onLinkClick: ', eve);
        var ele = eve.target;
        var target_m3id = $(ele).attr('m3link');

        if (target_m3id) {
          window.location.hash = target_m3id;
          var $target = $('[m3id="' + target_m3id + '"');
          if (this.debug) console.log('onLinkClick: target - ', $target); // if elementor, use the widget-container to compensate for margins

          if ($target.hasClass('elementor-element') && $target.find('> .elementor-widget-container').length) {
            $target = $target.find('> .elementor-widget-container')[0];
          }

          this.scrollTo($target);
        }
      }
    }, {
      key: "stopScroll",
      value: function stopScroll() {
        $([document.documentElement, document.body]).stop();
      }
      /**
       * Make userinteractions stop the automated scrolling
       */

    }, {
      key: "onScroll",
      value: function onScroll() {
        if (this.debug) console.log('onScroll'); // todo: only add the onscroll when animating, remove it afterwards, probably better than constantly checking on scroll (https://api.jquery.com/off/)

        if (this.is_animating) {
          this.stopScroll();
        }
      }
    }, {
      key: "onLoad",
      value: function onLoad() {
        var _this4 = this;

        if (this.debug) console.log('M3SmoothScroll: onLoad'); // HEADER LINK CLICK EVENTS
        // --------------------------------
        // if we have a header

        if ($('section[m3id="header"] a').length) {
          // loop over all the links in the header
          $('section[m3id="header"] a, section[m3id="footer"] a, [m3link="hashlink"] a').each(function (ind, ele) {
            if (_this4.debug) console.log('onLoad: ', ele); // check if the link is an internal one

            if ($(ele).attr('href') && $(ele).attr('href').indexOf('#') >= 0) {
              var _this4$_parseLink = _this4._parseLink(ele),
                  _this4$_parseLink2 = _slicedToArray(_this4$_parseLink, 2),
                  prefix = _this4$_parseLink2[0],
                  a_hashlink = _this4$_parseLink2[1]; // if we have a hashlink


              if (a_hashlink && a_hashlink.length > 0) {
                // save hashlikn for later usage
                $(ele).attr('m3link', a_hashlink);
                $(ele).on('click', function (e) {
                  _this4.onLinkClick(e); // if we have a link in the header


                  if ($(ele).closest('section[m3id="header"]').length) {
                    _this4.markActiveHeaderLink(e.target);
                  }

                  if (_this4.debug) console.log('internal link click: ', prefix, _this4.hashlink, window.location.pathname);

                  if (window.location.pathname == prefix) {
                    e.preventDefault();
                    e.stopPropagation();
                  }
                });
              } // with the not internal ones, if they are clicked even though they are already selected, scroll to top

            } else {
              $(ele).on('click', function (e) {
                // SAME PAGE: scroll to top
                if (_this4._isLink2CurrentPage(e.target)) {
                  _this4.scrollTo($('body'));

                  _this4.markActiveHeaderLink(ele);

                  window.location.hash = '';
                  e.preventDefault();
                  e.stopPropagation();
                }
              });
            }
          });
        } // STOP SCROLLING WHEN PAGE IS SCROLLED MANUALLY
        // -------------------------------------------------
        // todo: STOP SCROLLING WHEN PAGE IS SCROLLED MANUALLY
        // INITIAL SCROLL WHEN HASHLINK IS SET ON PAGE LOAD
        // ---------------------------------------------------


        if (this.hashlink) {
          // get the header link that ends with the hashlink that we've found
          var $targetLink = $('section[m3id="header"] a[href$="#' + this.hashlink + '"]');

          if ($targetLink.length) {
            // setTimeout(() => {
            setTimeout(function () {
              _this4.markActiveHeaderLink($targetLink);
            }, 500);
            $targetLink.trigger('click');
            window.location.hash = this.hashlink; // }, 500)
          }
        }

        this.markActiveHeaderLink();
      }
    }]);

    return M3SmoothScroll;
  }();

  var m3_smooth_scroll = new M3SmoothScroll();
  /**
     * Sticky Header class
     * -hide-below: hides after threshold pixel
     * -sticky-normal: css animation slide in / out
     * -direct-fade: scrollrelated fade-in / -out
     */

  var M3StickyHeader = /*#__PURE__*/function () {
    function M3StickyHeader() {
      var threshold = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 200;

      _classCallCheck(this, M3StickyHeader);

      this.debug = typeof m3_getQueryVariable == 'function' ? m3_getQueryVariable('debug-sticky-header') : false;
      if (this.debug) console.log('M3StickyHeader: constructor(' + threshold + ')');
      this.header_selector = '#m3-stickyheader.elementor-sticky--active';
      this.variants = ['-hide-below', '-sticky-normal', '-direct-fade'];
      this.threshold = threshold;
      this.izVisible = false;
      this.scroll_data = {
        variant_1: {
          visible_height: 0,
          threshold: 0,
          visible: false,
          // pixel is quicker for smaller heights
          use_pixel: true
        },
        pos: {
          last: -1,
          curr: 0,
          diff: 1,

          /** Accumulated movement in scroll direction */
          dir_acc: 0,

          /** Direction of scroll movement */
          dir_change: false
        }
      };
      this.init_data = {
        wait_max: 100,
        wait_delay: 50,
        interval: null,
        wait_count: 0
      };
      this.init();
    }

    _createClass(M3StickyHeader, [{
      key: "init",
      value: function init() {
        var _this5 = this;

        // TODO: put the wait into an external class
        if (this.debug) console.log('M3StickyHeader: init()');

        if ($('#m3-stickyheader')) {
          if (this.debug) console.log('M3StickyHeader: found id'); // waiting for initialization by Elementor

          this.init_data.interval = setInterval(function () {
            if ($(_this5.header_selector).length || _this5.init_data.wait_count > _this5.init_data.wait_max) {
              clearInterval(_this5.init_data.interval);

              _this5._setupEvents();
            } else {
              _this5.init_data.wait_count++;
            }
          }, this.init_data.wait_delay);
        }
      }
    }, {
      key: "_setupEvents",
      value: function _setupEvents() {
        if (this.debug) console.log('M3StickyHeader: _setupEvents()');

        if (!$(this.header_selector).length) {
          if (this.debug) console.log('M3StickyHeader: _setupEvents() > none found', this.header_selector);
          return;
        }

        this.$stickyheader = $(this.header_selector); // get the variant

        var _iterator = _createForOfIteratorHelper(this.variants.entries()),
            _step;

        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var _step$value = _slicedToArray(_step.value, 2),
                key = _step$value[0],
                val = _step$value[1];

            if (this.$stickyheader.hasClass(val)) {
              this.variant = key;
            }
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }

        $(window).scroll(this._onScroll.bind(this));

        this._onScroll();
      }
      /**
         * Variant 1, hide the sticky header if it is below a given threshold
         * @private
         */

    }, {
      key: "_hideBelowThreshold",
      value: function _hideBelowThreshold() {
        if (this.debug) console.log('M3StickyHeader: _hideBelowThreshold()', this.threshold, window.pageYOffset, this.$stickyheader);

        if (this.scroll_data.pos.curr <= this.threshold) {
          if (!this.izVisible) {
            this.$stickyheader.addClass('-show-sticky');
            this.$stickyheader.removeClass('-hide-sticky');
            this.izVisible = true;
          }
        } else {
          if (this.izVisible) {
            this.$stickyheader.removeClass('-show-sticky');
            this.$stickyheader.addClass('-hide-sticky');
            this.izVisible = false;
          }
        }
      }
    }, {
      key: "_directFade",
      value: function _directFade() {
        if (this.debug) console.log('M3StickyHeader: _directFade()', window.pageYOffset, this.scroll_data);
        var max_visible_height = this.scroll_data.variant_1.use_pixel ? this.$stickyheader.outerHeight() : 100; // opacity

        this.scroll_data.variant_1.visible_height += this.scroll_data.pos.diff; // TODO: don't do the calcs EVERY TIME
        // negative kinetic scroll fix

        if (window.pageYOffset >= 0) {
          this.$stickyheader.removeClass('-negative-y');
        } else {
          this.$stickyheader.addClass('-negative-y');
        } // hide if nothing is visible


        if (this.scroll_data.variant_1.visible_height < 0 && this.scroll_data.pos.curr > 0 // fixing safari kinetic scroll problem where the header is hidden when we scroll up into negative space
        && window.pageYOffset > 0) {
          if (this.debug) console.log('M3StickyHeader: _directFade(): hide if nothing is visible');
          this.scroll_data.variant_1.visible = false;
          this.scroll_data.variant_1.visible_height = 0;
          this.$stickyheader.css('opacity', 0);
          this.$stickyheader.css('transform', 'translateY(-100%)');
        } else // show if fully visible
          if (this.scroll_data.variant_1.visible_height > max_visible_height || this.scroll_data.pos.curr === 0) {
            if (this.debug) console.log('M3StickyHeader: _directFade(): show if fully visible');
            this.scroll_data.variant_1.visible_height = max_visible_height;
            this.$stickyheader.css('opacity', 1);
            this.$stickyheader.css('transform', 'translateY(0)');
            this.scroll_data.variant_1.visible = true; // transition phase with < 1 opacity and position
          } else {
            // don't do it for safari negative y kinetic scroll
            if (window.pageYOffset > 0) {
              if (this.debug) console.log('M3StickyHeader: _directFade(): transition phase with < 1 opacity and position');
              this.$stickyheader.css('opacity', this.scroll_data.variant_1.visible_height / max_visible_height);
              this.$stickyheader.css('transform', 'translateY(-' + (max_visible_height - this.scroll_data.variant_1.visible_height) + (this.scroll_data.variant_1.use_pixel ? 'px' : '%') + ')');
            } else {
              console.log('window.pageYOffset smaller zero: ', window.pageYOffset);
            }
          }
      }
    }, {
      key: "_onScroll",
      value: function _onScroll() {
        if (this.debug) console.log('M3StickyHeader: _onScroll()', this.scroll_data); // calculate all the related values

        this.scroll_data.pos.curr = window.pageYOffset;
        this.scroll_data.pos.diff = this.scroll_data.pos.last - this.scroll_data.pos.curr;
        this.scroll_data.pos.dir_change = this.scroll_data.pos.dir_acc < 0 && this.scroll_data.pos.diff > 0 || this.scroll_data.pos.dir_acc > 0 && this.scroll_data.pos.diff < 0;

        if (this.scroll_data.pos.dir_change) {
          this.scroll_data.pos.dir_acc = 0;
        }

        this.scroll_data.pos.dir_acc += this.scroll_data.pos.diff;
        this.scroll_data.pos.dir_up = this.scroll_data.pos.dir_acc > 0;
        this.scroll_data.pos.dir_down = !this.scroll_data.pos.dir_up; // VERSION 1: hide after threshold pixel

        switch (this.variant) {
          case 0:
            this._hideBelowThreshold();

            break;

          case 2:
            this._directFade();

            break;
        }

        this.scroll_data.pos.last = this.scroll_data.pos.curr;
      }
    }]);

    return M3StickyHeader;
  }();

  var m3_sticky_header = new M3StickyHeader();

  var M3WCQuantity = /*#__PURE__*/function () {
    function M3WCQuantity() {
      _classCallCheck(this, M3WCQuantity);

      this.debug = false;
      if (this.debug) console.log('M3WCQuantity: constructor()');
      this._selector_custom = 'm3-wc-quantity';
      this._selector_default = 'm3-add-wc-quantity';
      this.init_data = {
        wait_max: 60,
        wait_delay: 50,
        interval: null,
        wait_count: 0
      };
      this.init();
    }

    _createClass(M3WCQuantity, [{
      key: "init",
      value: function init() {
        var _this6 = this;

        // TODO: put the wait into an external class
        if (this.debug) console.log('M3WCQuantity: init()'); // waiting for initialization by Elementor

        this.init_data.interval = setInterval(function () {
          if ($('.' + _this6._selector_default + ':not(._initted)').length) {
            _this6._setupDefault();
          }

          if (_this6.debug) console.log('M3WCQuantity: ', $(_this6._selector_default).length, _this6._selector_default);

          if ($('.' + _this6._selector_custom).length || _this6.init_data.wait_count > _this6.init_data.wait_max) {
            if (_this6.debug) console.log('M3WCQuantity: found id', _this6.init_data.wait_count);
            clearInterval(_this6.init_data.interval);

            _this6._setupEvents(); // init as well when cart is reloaded


            $(document.body).on('updated_cart_totals', function () {
              if (_this6.debug) {
                console.log('M3WCQuantity:on > updated_cart_totals');
              }

              _this6._setupEvents();
            });
          } else {
            _this6.init_data.wait_count++;
          }
        }, this.init_data.wait_delay);
      }
      /**
         * Will add our custom divs to the default 'add-to-cart' widget so that our counter works on that one as well, so it
         * does not need the custom divs to be in the html, just the trigger class this._selector_default
         * @private
         */

    }, {
      key: "_setupDefault",
      value: function _setupDefault() {
        var _this7 = this;

        if (this.debug) console.log('M3WCQuantity:on > _setupDefault');
        $('.' + this._selector_default + ':not(._initted)').each(function (index, ele) {
          var $form = $(ele).find('form.cart');
          var $input = $(ele).find('.quantity input'); // DON'T initialize if we have a hidden quantity field (for example for only 1 item per oder)

          var izHidden = $input.parent().hasClass('hidden');
          var quantity_html = '<div class="' + _this7._selector_default + (izHidden ? ' hidden' : '') + '">' + '<div class="m3-wcq-minus">–</div>' + '<div class="m3-wcq-value"></div>' + '<div class="m3-wcq-plus">+</div>' + '<div class="m3-wcq-input"></div>' + '</div>';

          if ($form.find('.single_variation_wrap').length) {
            $form.find('.single_variation_wrap').prepend(quantity_html);
          } else {
            $form.prepend(quantity_html);
          }

          $form.addClass('product-quantity');
          var $quantity = $form.find('.' + _this7._selector_default);
          $quantity.attr('data-max', $input.attr('max'));
          $quantity.attr('data-min', $input.attr('min'));
          $quantity.attr('data-value', $input.attr('value')); // move the input field to new construct

          $(ele).find('.quantity').appendTo($(ele).find('.m3-wcq-input'));

          _this7._setupEvents();

          $(ele).addClass('_initted');
        });
      }
    }, {
      key: "_setupEvents",
      value: function _setupEvents() {
        var _this8 = this;

        if (this.debug) console.log('M3WCQuantity: _setupEvents()');
        var button_selector = '.' + this._selector_custom + ':not(._initted), .' + this._selector_default + ':not(._initted)';

        if (!$(button_selector).length) {
          if (this.debug) console.log('M3WCQuantity: _setupEvents() > none found - ' + button_selector);
          return;
        }

        $(button_selector).each(function (index, ele) {
          _this8._changeValue($(ele).find('> .m3-wcq-value'), 0);

          $(ele).find('> .m3-wcq-minus').on('click touch', function (e) {
            _this8._changeValue(e.target, -1);
          });
          $(ele).find('> .m3-wcq-plus').on('click touch', function (e) {
            _this8._changeValue(e.target, 1);
          });
          $(ele).addClass('_initted');
        });
      }
    }, {
      key: "_changeValue",
      value: function _changeValue(elem, step) {
        var $elem = $(elem);
        var $parent = $elem.parent();
        var min = parseInt($parent.data('min'));
        var max = parseInt($parent.data('max'));
        var val = parseInt($parent.data('value'));
        var new_val = val + step;

        if (isNaN(max)) {
          max = -1;
        }

        if (this.debug) console.log('M3WCQuantity: _changeValue', step, min, max, val);

        if (new_val >= min && (new_val <= max || max === -1)) {
          $elem.val(new_val);
          $parent.find('.m3-wcq-value').text(new_val);
          $parent.data('value', new_val);
          $parent.find('input').val(new_val);
          $parent.find('input').trigger('change');
        }
      }
    }]);

    return M3WCQuantity;
  }();

  var m3_wc_quantity = new M3WCQuantity();
  $(function () {
    // PREVENTING 'FORGOT PASSWORD' to jump
    $('.tp-lost-password').on('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
    });
  });
})(jQuery // , wp.customize
);